// Self-hosted vertical video section used on landing/product pages.
// Pair with makeVideoJsonLd from src/seo/structuredData.js so the page
// is eligible for video search results.
import React from "react";

const futura = "'Futura', sans-serif";

const GuideVideo = ({ src, poster, heading, caption, background = "white" }) => (
  <section style={{ background, padding: "70px 24px 40px" }}>
    <div style={{ maxWidth: "720px", margin: "0 auto", textAlign: "center" }}>
      {heading && (
        <h2
          style={{
            fontFamily: futura,
            fontSize: "clamp(26px, 3vw, 36px)",
            margin: "0 0 12px",
            letterSpacing: "-0.5px",
            color: "#111",
          }}
        >
          {heading}
        </h2>
      )}
      {caption && (
        <p
          style={{
            fontFamily: futura,
            fontSize: "16px",
            lineHeight: 1.6,
            color: "#444",
            maxWidth: "520px",
            margin: "0 auto 26px",
          }}
        >
          {caption}
        </p>
      )}
      <video
        controls
        playsInline
        preload="none"
        poster={poster}
        width={720}
        height={1280}
        style={{
          width: "100%",
          maxWidth: "340px",
          height: "auto",
          borderRadius: "16px",
          display: "block",
          margin: "0 auto",
          background: "#0c0c0c",
        }}
      >
        <source src={src} type="video/mp4" />
        Your browser doesn't support embedded video.
      </video>
    </div>
  </section>
);

export default GuideVideo;
